import React, { useRef, useState } from "react";
import { useThree, useFrame } from "@react-three/fiber";
import { Html, useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { easing } from "maath";

export default function SpineModel(props) {
  const group = useRef();
  const [dummy] = useState(() => new THREE.Object3D());

  const { viewport } = useThree();
  const { width, height } = viewport;

  // Calcula la posición del modelo responsive al tamaño de la ventana
  const scaleResponsive = width * 0.6;
  const scale = Math.min(scaleResponsive, 2);

  useFrame((state, dt) => {
    dummy.lookAt(state.pointer.x, state.pointer.y, 2);
    easing.dampQ(group.current.quaternion, dummy.quaternion, 0.25, dt);
  });
  const { nodes, materials } = useGLTF("/FuguSkeleton.glb");

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane.geometry}
        material={materials.Metal}
        position={[0, 0.5, 0]}
        rotation={[1.501, 0, 0]}
        scale={scale}
      />
    </group>
  );
}

useGLTF.preload('/FuguSkeleton.glb')
